import { render } from "./InputDetails.vue?vue&type=template&id=78c39612&scoped=true"
import script from "./InputDetails.vue?vue&type=script&lang=js"
export * from "./InputDetails.vue?vue&type=script&lang=js"

import "./InputDetails.vue?vue&type=style&index=0&id=78c39612&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c39612"]])

export default __exports__